import React, { forwardRef } from 'react'
import { Button } from 'antd'
import { useParams } from 'react-router-dom'
import { useAnalytics } from '../../hooks/useAnalytics'
import { EventMapper } from './utils'
import { useTracking } from '../../hooks/useTracking'
import DetailCard from '../common/detail-card'
import styled from 'styled-components'
import theme from '../../theme'
import { Shipment } from '../../types/Shipment'

type Props = {
  data?: Shipment
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  font-weight: 100;
  font-size: 16px;
  line-height: 21px;
  color: ${theme.midnight800};
`

const Note = styled.div`
  color: ${theme.slate500};
  font-size: 10px;
  line-height: 21px;
`

const formatCarrier = (carrier: string): string =>
  carrier
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

function ShipmentInfo(props: Props, ref: React.Ref<HTMLDivElement>) {
  const { data } = props
  const { uuid } = useParams()
  const { track } = useAnalytics()
  const { orderDetails } = useTracking()

  if (!data?.tracking_url || !uuid) {
    return null
  }

  const handleTrackEvent = (event: string) => {
    track(`Website Tracking Page ${EventMapper[event].event}`, {
      action: EventMapper[event].action,
      category: EventMapper[event].category,
      product: 'TrackOrder',
      orderId: String(orderDetails?.id),
    })
  }

  return (
    <DetailCard
      ref={ref}
      title={'✈️ Detailed tracking'}
      data-testid="shipment-info-card"
    >
      <Content>
        <Note>Tracking number: {data?.tracking_id}</Note>

        <Button
          data-testid="track-shipment-button"
          href={data?.tracking_url}
          onClick={() => handleTrackEvent('track dhl')}
        >
          {data?.carrier ? `Track with ${formatCarrier(data.carrier)}` : 'Track Order'}
        </Button>
      </Content>
    </DetailCard>
  )
}

export default forwardRef(ShipmentInfo)
